import { type UseQueryResult, useQuery } from 'react-query';
import { CriteriaTypeService } from '@wealthlane/api-services/wealthlane-tax-service';
import { type OptionType } from '../../types/common';

const useGetTaxUserDefinedOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionType[] | undefined,
  unknown
> => {
  const taxUserDefinedOptions = useQuery(
    ['getTaxUserDefinedOptions'],
    async () => {
      return await handleRequest(
        CriteriaTypeService.getApiTaxApiAppCriteriaTypeCriteriaTypesListAync()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.systemName ?? '',
          };
        });
      },
      cacheTime: 1000 * 60 * 5,
    }
  );

  return taxUserDefinedOptions;
};

export default useGetTaxUserDefinedOptions;
